import React from 'react';
import { Link, } from 'react-router';
import ReactDOM from 'react-dom';
import { history, } from '../../store';
import store from '../../store';
import $ from 'jquery';
import '../../../public/css/media/_account.scss';
import { Modal } from 'react-bootstrap';
import { serializeSpecialChars, ellipses, maskAddressErrorMessage, netcoreScript, prefixNumber, mapPrefixNumber, maskLocationName } from '../../utils/utils';
import { restrictedAreas } from '../../constants/restrictedAreas'
import { find } from 'lodash';
import RestrictedTooltip from '../../components/RestrictedTooltip'
import CloseIcon from './icons/times.svg'
import DropdownIcon from './icons/angle-left.svg'
import { handleAppUrl } from '../../utils/urls';
// import { renderFlagIconRound } from '../../utils/warehouseFlags';

const createReactClass = require('create-react-class');
const Account = createReactClass({

  componentWillMount() {
    window.location.href = `${handleAppUrl()}/my-account/account-info`;
    const script = document.createElement("script");
    script.setAttribute('class', 'lbcx');
    script.type = "text/javascript";
    script.src = "/js/custom.js";
    script.async = true;
    document.body.appendChild(script);

    var x = document.getElementsByClassName("lbcx");

    for (var i = 0; i < x.length; i++) {
      document.body.removeChild(x.item(i));
    }

    // if (this.props.login.hasOwnProperty('provinces')) {
    //   if (!this.props.login.provinces) {
    //     this.props.getProvinces();
    //   }
    // }
    if (this.props.login.hasOwnProperty('region')) {
      if (!this.props.login.region) {
        this.props.getRegions();
      }
    }
    const token = localStorage.jwtToken;
    this.props.signedIn(token);

    if (localStorage.account_redirect) {
      this.setState({
        activeTab: 'account_information'
      })
    }
  },
  getInitialState() {
    return {
      first_name: "",
      last_name: "",
      countryPrefix: "+63",
      add_countryPrefix: "+63",
      phone_number: "",
      address_phone_number: "",
      gender: "",
      birthdate: "",
      email: "",
      password_confirm: "",
      password: "",
      new_password: "",
      new_confirm_password: "",
      errors: {
        "Profile":
          {
            "first_name": " What's your first name? ",
            "last_name": " What's your last name? ",
            "phone_number": " What's your contact number.? ",
          },
        "Email": {
          "email": " Give us a valid email address ",
          "password_confirm": " Empty current password ",
        },
        "Password": {
          "password": " Empty current password ",
          "new_password": " New password must be greater than or equal to 6 characters ",
          "new_confirm_password": " Confirmed password must be greater than or equal to 6 characters ",
        },
        "Address": {
          "add_first_name": "",
          "add_last_name": "",
          "add_line_1": "Street Address",
          "add_line_2": "Barangay",
          "add_state": "",
          "add_city": "",
          "add_postal_code": "",
        },
      },
      focus_key: "",
      storeAddress: true,
      addressId: 0,
      add_first_name: "",
      add_last_name: "",
      street: "",
      region: "",
      country: "",
      province: "",
      city: "",
      district: "",
      postal_code: "",
      editProvince: {},
      fetchedCities: false,
      fetchedDistricts: false,
      enableProvince: false,
      enableCity: false,
      enableDistrict: false,
      IsFormSubmitted: false,
      IsEditingInput: false,
      IsProfileUp: false,
      IsEmailUp: false,
      IsPasswordUp: false,
      profileClicked: false,
      emailClicked: false,
      passwordClicked: false,
      // Modal
      showModal: false,
      deleteAddressModal: "",
      modalTitle: '',
      submitText: 'Submit', // HAM : this is so we don't get the uncontrolled/controlled component warning for address submit button
      phoneNumberUpdated: false,
      activeTab: 'address_book',
      isAddressDeletionSuccess: false,
    }
  },


  loadAddresses(e) {
    e.preventDefault();
    this.clrErrorMsgs('Address');
    this.resetAll();
    this.setState({ activeTab: 'address_book' });
  },
  loadAccounts(e) {
    e.preventDefault();
    this.clrErrorMsgs('Profile');
    this.resetAll();
    this.setState({ activeTab: 'account_information' });
  },
  loadRewards(e) {
    e.preventDefault();
    this.clrErrorMsgs();
    this.resetAll();
  },
  // handles on click of add address button
  handleAddButton(e) {
    this.resetAll();
    window.scrollTo(0, 0);
    e.preventDefault();
    // ReactDOM.findDOMNode(this.refs.modal_header).innerHTML = "Add Address";
    // ReactDOM.findDOMNode(this.refs.add_first_name).focus();
    this.setState({
      storeAddress: true,
      modalTitle: 'Add Address',
      submitText: "SAVE",
      enableProvince: false,
      enableCity: false,
      enableDistrict: false,
      focus_key: "add_first_name",
      add_first_name: "",
      add_last_name: "",
      street: "",
      country: "",
      province: "",
      city: "",
      district: "",
      postal_code: "",
      region: "",
      showModal: true,
    }, () => {
      this.clrErrorMsgs("Address");
      this.refs.add_first_name.focus();
    });
  },
  // handles on click of edit address button
  handleEditButton(e, addressId) {
    e.preventDefault();
    this.setState({isAddressDeletionSuccess: false})
    this.setState({ modalTitle: 'Edit Address', showModal: true}, () => {
      this.refs.add_first_name.focus();
    });
    // TODO:  This is just a work around find another way to trigger edit link to show modal address on REFRESH 2/22/2017    
   // this.refs.add_address.click(); // <---- HAM : WTF!!! 
    // ReactDOM.findDOMNode(this.refs.modal_header).innerHTML = "Edit Address";
    this.setState({ });
    // ReactDOM.findDOMNode(this.refs.add_first_name).focus();
    //console.log(this.addFirstNameInput);
    this.setState({
      submitText: "Save",
      enableProvince: true,
      enableCity: true,
      enableDistrict: true,
      focus_key: "add_first_name",
      fetchedDistricts: false,
      district: ""
    });

    // var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
    try {
      if (this.props.login.hasOwnProperty('login')) {
        // Map the object from the list of address
        var obj = this.props.login.login.party.addresses.filter(function (i) {
          return i.id === addressId;
        })[0];

        if (this.isNotEmptyObj(obj)) {
          this.setState({
            addressId: addressId,
            add_first_name: obj.full_name.first_name,
            add_last_name: obj.full_name.last_name,
            street: obj.line_1,
            country: obj.country_code,
            province: obj.state,
            city: obj.city,
            district_name: obj.line_2,
            postal_code: obj.postal_code,
            add_countryPrefix : obj.phone_number ? obj.phone_number.substring(0, 3) : '',
            address_phone_number: obj.phone_number ? obj.phone_number.substring(3) : '',
          }, function () {
            this.props.getProvinces(obj.country_code);
            var selectedProvince = ReactDOM.findDOMNode(this.refs.province);
            var province_id = 0;
            var region_id = 0;

            setTimeout(() => {
              for (let i = 0; i < selectedProvince.options.length; i++) {
                if (selectedProvince.options[i].value === obj.state) {
                  province_id = selectedProvince.options[i].getAttribute('data-province-id');
                  region_id = selectedProvince.options[i].getAttribute('data-region');
                  break;
                }
              }

              if(this.state.country === "PH") {
                this.setRegion(region_id);
              }

              // if province id was set.
              if (province_id > 0) {
                // this.setState({ storeAddress: false, });
                var t = this;
                t.unsubscribe = store.subscribe(function () {
                  var selectedCity = ReactDOM.findDOMNode(t.refs.city);
                  var city_id = 0;
                  for (let i = 0; i < (selectedCity ? selectedCity.options.length : null); i++) {
                    if (selectedCity.options[i].value === obj.city) {
                      city_id = selectedCity.options[i].getAttribute('data-city-id');
                      break;
                    }
                  }
                  if (city_id > 0) {
                    t.props.getDistricts(city_id);
                    if (typeof t.unsubscribe === 'function') {
                      t.unsubscribe();
                    }
                  }
                })
                // get the cities belongs to this province.
                this.props.getCities(province_id);
              }

              setTimeout(() => {
                //set district id state
                if (this.props.login && this.props.login.district_fetched) {
                  this.setState({ district: (this.props.login.districts.data || this.props.login.districts).find(d => d.postal_code === obj.postal_code && d.name === obj.line_2).id})
                }
              }, 2900)
            },2300);
          });
        }
      }
    } catch (ex) {
      return false;
    }
  },
  handleDeleteButton(addressId) {
    // e.preventDefault();
    this.clrErrorMsgs("Address");
    this.setState({isAddressDeletionSuccess: false})
    // var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
    this.props.deleteAddress(addressId).then((res) => {
      if (res && res.data && res.data.is_success) {
        this.setState({isAddressDeletionSuccess: true})
      }
    });
    this.setState({deleteAddressModal: ""})
  },
  handleMakeDefaultButton(e) {
    e.preventDefault();
    this.clrErrorMsgs("Address");
    var addressId = parseInt(e.target.getAttribute('data-address-id'), 10) || 0;
    if (addressId > 0) {
      this.props.setDefaultAddress(addressId);
    }
  },
  formAddress(e) {
    e.preventDefault();
    const token = localStorage.jwtToken;
    var parameters = {
      token,
      "first_name": this.state.add_first_name,
      "middle_initial": "",
      "last_name": this.state.add_last_name,
      "line_1": this.state.street,
      "type": "delivery",
      "line_2": this.state.district_name,
      "city": this.state.city,
      "state": this.state.province,
      "postal_code": this.state.postal_code,
      "region": this.state.region,
      "country_code": this.state.country,
      "phone_number": this.state.add_countryPrefix && this.state.address_phone_number && `${this.state.add_countryPrefix}${this.state.address_phone_number}`
    };
    // if true then it will add else update
    if (!this.state.addressId) {
      this.props.addAddress(parameters);
    }
    else {
      this.props.editAddress(this.state.addressId, parameters);
    }
    this.setState({ IsFormSubmitted: true, }, () => {
      this.clrErrorMsgs("Address");
    });
    
  },
  handleInputChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    if (name === "last_name" || name === "first_name") {
      this.setState({ [name]: serializeSpecialChars(value) });
    }else if(name === "countryPrefix"){
      this.setState({ [name]: value });
      this.setState({ phone_number: "" });
    }else if(name === "add_countryPrefix"){
      this.setState({ [name]: value });
      this.setState({ phone_number: "" });
    }else {

      this.setState({ [name]: value });
    }

    this.setState({
      IsEditingInput: true,
    });
  },
  handleCountries(e) {
    this.setState({
      country: e.target.value,
      enableProvince: (e.target.value ? true : false),
      enableCity: false,
      enableDistrict: false,
      province: "",
      region: "",
      city: "",
      district: "",
      postal_code: ""
    }, () => {
      this.props.getProvinces(this.state.country);
    })
  },
  handleProvinces(e) {
    var index = e.nativeEvent.target.selectedIndex;
    const province_id = e.nativeEvent.target[index].getAttribute('data-province-id') || 0;
    const region_id = e.nativeEvent.target[index].getAttribute('data-region') || 0;
    if(this.state.country === "PH") {
      this.setRegion(region_id);
    }
    if (province_id !== 0) {
      this.props.getCities(province_id);
    } else {
      this.props.resetLocationCalls('GET_CITY_FULFILLED');
      this.props.resetLocationCalls('GET_DISTRICT_FULFILLED');
    }
    this.setState({
      province: e.target.value,
      enableCity: (e.target.value ? true : false),
      // enableDistrict:(e.target.value ? true:false),
      city: "",
      district: "",
      postal_code: "",
    });
  },
  handleCities(e) {
    var index = e.nativeEvent.target.selectedIndex;
    const city_id = e.nativeEvent.target[index].getAttribute('data-city-id') || 0;
    if (city_id !== 0) {
      this.props.getDistricts(city_id);
    } else {
      this.props.resetLocationCalls('GET_DISTRICT_FULFILLED');
    }
    this.setState({
      city: e.target.value,
      enableDistrict: (e.target.value ? true : false),
      district: "",
      postal_code: "",
    });
  },
  handleDistricts(e) {
    var index = e.nativeEvent.target.selectedIndex;
    const postal_code = e.nativeEvent.target[index].getAttribute('data-postal-code') || "";
    const district_name = e.nativeEvent.target[index].getAttribute('data-district-name') || "";
    this.setState({
      district: e.target.value,
      district_name: district_name,
      postal_code: postal_code,
    });
  },
  handleProfile(e) {
    e.preventDefault();
    let phoneNumberUpdated = false;
    if (!this.state.countryPrefix) {
      return (
        this.refs.errors_phone_number.innerHTML = 'Please select country prefix',
        this.refs.errors_phone_number.className = "input-error",
        this.refs.errors_phone_number.parentElement.className = "control has-error"
      )
    }
    if (this.state.phone_number.length < 7) {
      return (
        this.refs.errors_phone_number.innerHTML = 'The phone number must be at least 7 characters.',
        this.refs.errors_phone_number.className = "input-error",
        this.refs.errors_phone_number.parentElement.className = "control has-error"
      )
    }
    if (this.props.login.login.party.phone_number && this.props.login.login.party.phone_number.slice(3, 13) !== this.state.phone_number) {
      phoneNumberUpdated = true
    }
    if (!this.props.login.login.party.phone_number && this.state.phone_number) {
      phoneNumberUpdated = true
    }
    this.setState({ focus_key: "first_name", });
    const first_name = this.refs.first_name.value;
    const last_name = this.refs.last_name.value;
    const phone_number = this.state.countryPrefix+this.refs.phone_number.value;
    const token = localStorage.jwtToken;
    const gender = this.state.gender;
    const birthday = this.refs.birthday.value ? this.formatDateOnly(this.refs.birthday.value, '/', '-') : '';
    if (!phoneNumberUpdated){
      this.props.updateCustomerProfile(null,null,phoneNumberUpdated, first_name, last_name, phone_number, gender, birthday, token);
    } else {
      this.props.putReSendOTP(null, phoneNumberUpdated, first_name, last_name, phone_number, gender, birthday, token)
    }
    this.setState({ IsFormSubmitted: true, });
    this.clrErrorMsgs("Profile");
  },
  handleEmail(e) {    
    e.preventDefault();
    this.setState({ focus_key: "email", });
    const email = this.state.email;
    const password_confirm = this.state.password_confirm;
    const token = localStorage.jwtToken;    
    this.props.updateCustomerEmail(email, password_confirm, token);
    this.setState({ IsFormSubmitted: true, });
    this.clrErrorMsgs("Email");
  },
  handlePassword(e) {
    e.preventDefault();
    this.setState({ focus_key: "password", });
    const password = this.refs.password.value;
    const new_password = this.refs.new_password.value;
    const new_confirm_password = this.refs.new_confirm_password.value;
    const token = localStorage.jwtToken;
    this.props.updateCustomerPassword(password, new_password, new_confirm_password, token);
    this.setState({ IsFormSubmitted: true, });
    this.clrErrorMsgs("Password");
  },
  handleCancel(str, cancelOnly, e) {
    e.preventDefault();
    this.clrErrorMsgs(str);
    this.resetAll();
    if (str && cancelOnly) {
      var name = 'Is' + str + 'Up';
      this.setState({
        [name]: false,
        showModal: false,
      });
      window.scrollTo(0, 0);
    }
    return false;
  },
  toggleProfile(str, e) {
    this.handleCancel(str, false, e);
    if (this.state.profileClicked && this.state.IsProfileUp) {
      this.setState({ profileClicked: false, IsProfileUp: false, },
        () => { this.refs.profile_cancel.click(); });
    } else {
      this.setState({
        IsProfileUp: true,
        profileClicked: true,
      });
    }
    if (this.state.IsEmailUp) { this.refs.email_cancel.click(); }
    if (this.state.IsPasswordUp) { this.refs.password_cancel.click(); }
    ReactDOM.findDOMNode(this.refs.first_name).focus();
    return false;
  },
  toggleEmail(str, e) {
    this.handleCancel(str, false, e);
    if (this.state.emailClicked && this.state.IsEmailUp) {
      this.setState({ emailClicked: false, IsEmailUp: false, },
        () => { this.refs.email_cancel.click(); });
    } else {
      this.setState({
        IsEmailUp: true,
        emailClicked: true,
      });
    }
    if (this.state.IsProfileUp) { this.refs.profile_cancel.click(); }
    if (this.state.IsPasswordUp) { this.refs.password_cancel.click(); }
    ReactDOM.findDOMNode(this.refs.email).focus();
    return false;
  },
  togglePassword(str, e) {
    this.handleCancel(str, false, e);
    if (this.state.passwordClicked && this.state.IsPasswordUp) {
      this.setState({ passwordClicked: false, IsPasswordUp: false, },
        () => { this.refs.password_cancel.click(); });
    } else {
      this.setState({
        IsPasswordUp: true,
        passwordClicked: true,
      });
    }
    if (this.state.IsProfileUp) { this.refs.profile_cancel.click(); }
    if (this.state.IsEmailUp) { this.refs.email_cancel.click(); }
    ReactDOM.findDOMNode(this.refs.password).focus();
    return false;
  },
  componentWillReceiveProps: function (nextProps) {
    if (!this.state.IsFormSubmitted && !this.state.IsEditingInput) {
      this.setState({
        first_name: nextProps.login.fetched ? (nextProps.login.login.party.first_name ? nextProps.login.login.party.first_name : "") : "",
        last_name: nextProps.login.fetched ? (nextProps.login.login.party.last_name ? nextProps.login.login.party.last_name : "") : "",
        phone_number: nextProps.login.fetched ? (prefixNumber(nextProps.login.login.party.phone_number.slice(0,3)) ? nextProps.login.login.party.phone_number.slice(3) : nextProps.login.login.party.phone_number) : "",
        countryPrefix: nextProps.login.fetched ? (prefixNumber(nextProps.login.login.party.phone_number.slice(0,3)) ? nextProps.login.login.party.phone_number.slice(0,3) : "") : "",
        gender: nextProps.login.fetched ? (nextProps.login.login.party.gender ? nextProps.login.login.party.gender : "") : "",
        birthdate: nextProps.login.fetched ? (nextProps.login.login.party.birthdate ? nextProps.login.login.party.birthdate : "") : "",
        email: nextProps.login.fetched ? (nextProps.login.login.party.email ? nextProps.login.login.party.email : "") : "",
      },() => {
        this.setState({
          phone_number: this.state.phone_number.length > 10 ? '' : this.state.phone_number
        })
      });
    }
    if (nextProps.login.updateProfileData && nextProps.login.updateProfileData.data){
      this.setState({
        successUpdateProfile: true
      })
    }
    $('#SCTitle').text("Account | ShippingCart");
  },
  componentDidUpdate(prevProps) {
    // PRE SELECT CITY FROM ADDRESS INFO
    if (this.props.login.hasOwnProperty('cities') && !this.state.fetchedDistricts) {
      // this will prevent the component to update forever!!
      if (this.props.login.cities && !this.state.storeAddress) {
        if (this.isNotEmptyObj(this.props.login.cities)) {
          var selected = ReactDOM.findDOMNode(this.refs.city);
          var city_id = 0;
          for (let i = 0; i < selected.options.length; i++) {
            if (selected.options[i].value === this.state.city) {
              city_id = selected.options[i].getAttribute('data-city-id');
              break;
            }
          }
          city_id = parseInt(city_id, 10) || 0;
          // if city id was set.
          if (city_id > 0) {
            this.setState({ fetchedDistricts: true, });
            // get the districts belongs to this city.
            this.props.getDistricts(city_id);
            this.setState({
              enableCity: true,
              enableDistrict: true,
            });
          }
        } else {
          this.setState({
            enableCity: false,
            enableDistrict: false,
          });
        }
      }
    }

    // // PRE SELECT DISTRICT FROM ADDRESS INFO
    // if(this.props.login.hasOwnProperty('districts')  && !this.state.fetchedDistricts){
    //   // this will prevent the component to update forever!!
    //   if(this.props.login.districts && !this.storeAddress){
    //     if(this.isNotEmptyObj(this.props.login.districts)){
    //       var selected =  ReactDOM.findDOMNode(this.refs.districts);
    //       for (let i = 0; i < selected.options.length; i++) {
    //           if (selected.options[i].text === this.state.editAddress.line_2) {
    //               selected.selectedIndex = i;
    //               break;
    //           }
    //       }
    //       this.setState({fetchedDistricts:true});
    //     }
    //   }
    // }
    if (this.state.IsFormSubmitted) {
      try {
        var status = this.props.login.error ? this.props.login.error.response ? this.props.login.error.response.status : this.props.login.error.status : 200;
        // clear error or success fields.
        // this.clrErrorMsgs();
        // if there's an error
        if (status !== 200) {
          // failed validation
          if (status === 422) {
            var params = this.props.login.error.response ? this.props.login.error.response.data.errors : this.props.login.error.data.errors;
            if (this.state.focus_key) {
              this.refs["notify_error_" + this.state.focus_key].className = "sc-alert sc-alert-danger";
              this.refs["notify_error_" + this.state.focus_key].parentElement.className = "notify";
              ReactDOM.findDOMNode(this.refs["notify_error_" + this.state.focus_key].parentElement.parentElement.parentElement).scrollIntoView(true);
            }
            var focus = true;
            if (params) {
              for (var ek in params) {
                if (params.hasOwnProperty(ek)) {
                  if (params[ek]) {
                    var str = (this.state.focus_key === "add_first_name" ? "errors_add_" : "errors_") + params[ek].title;
                    if (this.refs[str]) {
                      this.refs[str].innerHTML = maskAddressErrorMessage(params[ek].detail, this.state.country);
                      this.refs[str].className = "input-error";
                      this.refs[str].parentElement.className = "control has-error";
                      if (focus) {
                        ReactDOM.findDOMNode(this.refs[str].nextSibling).focus();
                        focus = false;
                      }
                    }
                  }
                }
              }
            }
          }
          this.setState({ IsFormSubmitted: false, });
        } else {
          if (this.props.login.updateEmail || this.props.login.updatePassword || this.props.login.addAddress || this.props.login.editAddress || this.props.login.updateProfile) {
            // This will handles the Update from adding and updating Address information
            if (this.props.login.addAddress || this.props.login.editAddress) {
              // if true then close the modal and reset its info.
              // this.refs.modal_address_cancel.click();
              this.setState({ showModal : false});
            }
            if (this.state.focus_key) {
              this.refs["notify_success_" + this.state.focus_key].className = "sc-alert sc-alert-success";
              this.refs["notify_success_" + this.state.focus_key].parentElement.className = "notify";
              if (this.state.focus_key === "add_first_name") {
                this.refs.addressSuccessText.innerHTML = (this.props.login.addAddress ? "You've added a new address." : (this.props.login.editAddress ? "You've successfully updated your address." : ""));

                ReactDOM.findDOMNode(this.refs.address_book.parentElement.parentElement.parentElement).scrollIntoView(true);
              } else {
                ReactDOM.findDOMNode(this.refs["notify_success_" + this.state.focus_key].parentElement.parentElement.parentElement).scrollIntoView(true);
              }
            }
            this.setState({ IsFormSubmitted: false, });
          }
        }
      } catch (ex) {
        return false;
      }
    }

    if (this.props.login.error) {
      if (this.props.login.error.response) {
        if (this.props.login.error.response.status === 401) {
          history.push("/signin");
        }
      }
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0);

    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->    
  },
  componentWillUnmount() {
    this.setState({ focus_key: "", });
    this.props.resetAccounts();
    // this.clrErrorMsgs();
    localStorage.removeItem('account_redirect');
  },
  formatDateOnly(arr, separator, format) {
    if (arr) {
      if (separator === "/") {
        arr = arr.split(separator);
        arr.unshift(arr[arr.length - 1]);
        arr.pop();
        return arr.join(format);
      } else if (separator === "-") {
        arr = arr.split(separator);
        arr.push(arr[0]);
        arr.shift();
        return arr.join(format);
      }

    }
    else {
      arr = "mm/dd/yyyy";
    }
    return arr;
  },
  clrErrorMsgs(notify = "") {
    var errors = this.state.errors;
    // clear here the labels original text
    for (var k in errors) {
      if (errors.hasOwnProperty(k)) {
        var listError = (notify) ? errors[notify] : errors[k];
        // clear here the labels original text
        for (var err in listError) {
            if (listError.hasOwnProperty(err)) {
              if(this.refs.hasOwnProperty('errors_' + err)){
                this.refs["errors_" + err].className = "disnone";
                this.refs["errors_" + err].innerHTML = listError[err];
                this.refs["errors_" + err].parentNode.className = "control";
              }
            }
        }
      }
      this.setState({ successUpdateProfile: false })
    }
    var focus_key = { "Address": "add_first_name", "Profile": "first_name", "Email": "email", "Password": "password", };
    if (focus_key[notify]) {
      this.refs["notify_success_" + focus_key[notify]].parentElement.className = "disnone";
      this.refs["notify_success_" + focus_key[notify]].className = "disnone";
      if(this.refs.hasOwnProperty('notify_error_' + focus_key[notify])){
        this.refs["notify_error_" + focus_key[notify]].className = "disnone";
      }
      
    } else {
      for (var j in focus_key) {
        if (focus_key.hasOwnProperty(j)) {
          this.refs["notify_success_" + focus_key[j]].parentElement.className = "disnone";
          this.refs["notify_success_" + focus_key[j]].className = "disnone";
          this.refs["notify_error_" + focus_key[j]].className = "disnone";
        }
      }
    }
    this.setState({password_confirm:""})
    this.refs.password.value = "";
    this.refs.new_password.value = "";
    this.refs.new_confirm_password.value = "";
  },
  resetAll() {
    this.setState({
      focus_key: "",
      storeAddress: true,
      addressId: 0,
      add_first_name: "",
      add_last_name: "",
      street: "",
      region: "",
      province: "",
      city: "",
      district: "",
      postal_code: "",
      editProvince: {},
      fetchedCities: false,
      fetchedDistricts: false,
      enableProvince: false,
      enableCity: false,
      enableDistrict: false,
      IsFormSubmitted: false,
      IsEditingInput: false,
    });
    this.props.resetAccounts();
    // const gender =  this.props.login.fetched ? this.props.login.login.party.gender : null;
    // if(gender)
    //   ReactDOM.findDOMNode(this.refs[gender]).checked = true;
    // var birthdate = this.props.login.fetched ? this.props.login.login.party.birthdate : null;
    // if(birthdate){
    //   birthdate = this.formatDateOnly(birthdate,'-','/');
    //   ReactDOM.findDOMNode(this.refs.birthdate).innerHTML = birthdate;
    //   ReactDOM.findDOMNode(this.refs.birthday).value = birthdate;
    // }
  },
  // this will check if object is empty or not. by Adam Zerner on StackOverFlow : Used By Rexgama
  isNotEmptyObj(obj) {
    const result = (Object.keys(obj).length !== 0 && obj.constructor === Object);
    return result;
  },
  setRegion(id) {
    const region_id = parseInt(id, 10) || 0;
    // Map the object from the list of address
    if (this.props.login.hasOwnProperty('region') && region_id > 0) {
      var regionObj = this.props.login.region.data.filter(function (i) {
        return i.id === region_id;
      })[0];
      if (this.isNotEmptyObj(regionObj)) {
        if (regionObj.hasOwnProperty('name')) {
          this.setState({
            region: regionObj.name,
          });
        }
      }
    } else {
      this.setState({
        region: "",
      });
    }
  },
  handleModalHide() {
    this.setState({ showModal: false});
  },
  handleEnableButton(){
    if(this.props.login.fetched){
      if (this.props.login.login.party.email === this.state.email){
        if (!this.state.password_confirm){
          return true;
        }
        if(this.props.login.login.party.fb_id){
          if (!this.state.password_confirm){
            return false;
          }
        }
        return true;
      }
      return false;
    }
  },
  handleShowPassword(e) {
    const name = e.target.name;
    if (this.refs['show_'+name].checked) {
      this.refs[name].type = 'text';
    } else {
      this.refs[name].type = 'password';
    }
  },
  renderAddresses() {
    if (!this.props.login.fetched) return;
    const addresses = [...this.props.login.login.party.addresses];
    this.props.login.login.party.addresses.forEach((address) => {
      let isRestricted= false
      find(restrictedAreas.provinces, function(restrictedArea) {
         if (address.state === restrictedArea.province) {
          isRestricted = true
         }
      })
      if (!isRestricted) {
        find(restrictedAreas.cities, function(restrictedArea) {
          if (address.state === restrictedArea.province && address.city === restrictedArea.city ) {
           isRestricted = true
          }
       })
      }
      if (!isRestricted) {
        find(restrictedAreas.brgys, function(restrictedArea) {
          if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy ) {
           isRestricted = true
          }
       })
      }
      if (isRestricted) {
        address.isRestricted = true;
      }
    })
    return (
    <ul
      style={{
        display: "flex",
        flexFlow: "row wrap"
      }}>
      <li className="tab-box address-box-wrapper">
        <div className='make-default add-address-box' onClick={(e) => this.handleAddButton(e)}>
          <i className="fa fa-plus" aria-hidden="true" style={{alignSelf: "end", fontSize: "24px"}}/>
          Add address
        </div>
      </li>
      {addresses.filter(add => this.props.login.login.party.address_id === add.id || addresses.length === 1).map((add, i) =>
      <li style={{ minHeight: "190px"}} className="tab-box address-box-wrapper" key={i}>
        <div className='make-default' id='default'>
          <p>
            {(add.full_name || JSON.parse(add.name)).first_name} {(add.full_name || JSON.parse(add.name)).last_name}
            <br />
            <span className="address" style={{color: '#333333'}}>
            {`${ellipses(add.line_1, 85)}, ${add.line_2}, ${add.city}, ${add.state}, ${maskLocationName(add.country_code)}, ${add.postal_code}`}
            {/* <img src={renderFlagIconRound(add.country_code)} alt="flags" height="30" width="30"/> */}
            </span>
            <span style={{ display: 'block', color: '#333333' }}>{add.phone_number || this.props.login.login.party.phone_number}</span>
          </p>
          {/* <hr /> */}
          { add.isRestricted && <RestrictedTooltip /> }
          <div style={{alignSelf: "center", display: "inline-flex", placeContent: "space-between"}}>
            <span className="account-default-button-disabled default-p">Default</span>
            <div style={{display: "inline-flex"}}>
            <a onClick={(e) => this.handleEditButton(e, add.id)} data-address-id={add.id} className="pull-right" data-do="edit-address" data-on="click" style={{float: 'none', marginRight: "15px", color: "#707070", fontSize: "24px"}}><i className="fa fa-pencil" aria-hidden="true"/> </a>
            <i className="fa fa-trash" aria-hidden="true" style={{fontSize: "24px", color: "#C6C6C6", alignSelf: "center", marginRight: "10px"}}/>
            </div>
          </div>
        </div>
      </li>)}
    {addresses.filter(add => this.props.login.login.party.address_id !== add.id && addresses.length > 1 ).map((add, i) =>
      <li style={{ minHeight: "190px"}} className="tab-box address-box-wrapper" key={i}>
        <div className='make-default' id={ this.props.login.login.party.address_id === add.id && !add.isRestricted && 'default' }>
          <p>
            {(add.full_name || JSON.parse(add.name)).first_name} {(add.full_name || JSON.parse(add.name)).last_name}
            <br />
            <span className="address" style={{color: '#333333'}}>
            {`${ellipses(add.line_1, 85)}, ${add.line_2}, ${add.city}, ${add.state}, ${maskLocationName(add.country_code)}, ${add.postal_code}`}
            {/* <img src={renderFlagIconRound(add.country_code)} alt="flags" height="30" width="30"/> */}
            <span style={{ display: 'block', color: '#333333' }}>{add.phone_number || this.props.login.login.party.phone_number}</span>
            </span>
          </p>
          {/* <hr /> */}
          { add.isRestricted && <RestrictedTooltip /> }
          <div style={{alignSelf: "center", display: "inline-flex", placeContent: "space-between"}}>
            { this.props.login.login.party.address_id === add.id && !add.isRestricted ? <span className="account-default-button-disabled default-p">Default</span> :
            <button onClick={this.handleMakeDefaultButton} data-address-id={add.id} className="account-default-button" disabled={ add.isRestricted && true}> Set as default</button>
            }
            <div style={{display: "inline-flex"}}>
            <a onClick={(e) => this.handleEditButton(e, add.id)} data-address-id={add.id} data-do="add-address" data-on="click" style={{float: 'none', marginRight: "15px", color: "#707070", fontSize: "24px"}}><i className="fa fa-pencil" aria-hidden="true"/> </a>
            {this.props.login.login.party.address_id !== add.id ?
              <a onClick={() => this.setState({ deleteAddressModal: add.id })} data-on="click" style={{float: 'none', marginRight: "10px", color: "#707070", fontSize: "24px"}}><i className="fa fa-trash" aria-hidden="true"/> </a>
              : <i className="fa fa-trash" aria-hidden="true" style={{fontSize: "24px", color: "#C6C6C6", alignSelf: "center", marginRight: "10px"}}/>
            }
            </div>
          </div>
        </div>
      </li>
      )}
    </ul>)
  },
  render() {
    return (
      <div className="main-content account-content">

        <ul className="nav nav-tabs lbcx-tabs" role="tablist">

          <li role="presentation" className={this.state.activeTab === 'address_book' ? 'active' : ''}><Link to="#address_book" onClick={this.loadAddresses} aria-controls="active" role="tab" data-toggle="tab">Address Book</Link></li>
          <li role="presentation" className={this.state.activeTab === 'account_information' ? 'active' : ''}><Link to="#account_information" onClick={this.loadAccounts} aria-controls="archive" role="tab" data-toggle="tab">Account Information </Link></li>
          {/*<li role="presentation"><Link to="#rewards" onClick={this.loadRewards}  aria-controls="archive" role="tab" data-toggle="tab"> Rewards </Link></li>*/}
        </ul>

        <hr className="account-hr" />

        <br />
        <div className="tab-content" style={{width: "99%"}}>
          <div role="tabpanel" className={`tab-pane ${this.state.activeTab === 'address_book' ? 'active' : ''}`} id="address_book" ref="address_book">
            <div className="clearfix">
            </div>
            <div className="disnone">
              <div ref="notify_success_add_first_name" className="sc-alert sc-alert-success">
                <i className="sc"></i><span ref="addressSuccessText"> Address.</span>
              </div>
            </div>
            <div className="clearfix">
            </div>
            <div className="tab-header">
              Delivery Address &nbsp;
              {/* <Link to="">
                <i className="fa fa-question-circle fa-fw">
                  <div className="tooltip white">
                    <p>This will serve as your delivery address in the Philippines.</p>
                  </div>
                </i>
              </Link> */}
            </div>
            {
            this.state.isAddressDeletionSuccess && <div className='deleted-message'>Address has been successfully deleted. <span className='deleted-message-span' onClick={() => {this.setState({isAddressDeletionSuccess: false})}}><img src={CloseIcon} alt='close' /></span></div>
            }
            {/* ADDRESS LIST START */}
            { this.renderAddresses() }
            {/* ADDRESS LIST END */}
          </div>
          <div role="tabpanel" className={`tab-pane ${this.state.activeTab === 'account_information' ? 'active' : ''}`} id="account_information">
            <div className="tab-header2">
              <table >
                <tbody >
                  <tr>
                    <td>
                      {/* PROFILE DIV START */}
                      {this.state.IsProfileUp ?
                        <div className="edit-account" onClick={this.toggleProfile.bind(this, "Profile")} data-toggle="collapse" data-target="#profile" aria-hidden="true">
                          <i className="fa fa-caret-down pull-left"></i>
                          <span className="pull-left ">Profile</span>
                        </div>
                        :
                        <div className="collapsebtn edit-account" data-toggle="collapse" data-target="#profile" aria-hidden="true" onClick={this.toggleProfile.bind(this, "Profile")}>
                          <i className="fa fa-caret-right pull-left  "></i>
                          <span className="pull-left ">Profile</span>
                          <a className="pull-right collapsebtn" data-toggle="collapse" data-target="#profile" aria-hidden="true" onClick={this.toggleProfile.bind(this, "Profile")}> Edit</a>
                        </div>
                      }
                      <div id="profile" className="collapse">
                        <div></div>
                        <form className="account-info" method="POST" onSubmit={this.handleProfile}>
                          <div className="disnone">
                            <div ref="notify_success_first_name" className="sc-alert sc-alert-success"><i className="sc"></i>Profile successfully updated.</div>
                            <div ref="notify_error_first_name" className="sc-alert sc-alert-danger"><i className="sc"></i>Please validate all fields.</div>
                            {/* {this.state.successUpdateProfile ? <div ref="notify_success_first_name" className="sc-alert sc-alert-success"><i className="sc"></i>Profile successfully updated.</div> : null} */}
                          </div>
                          <div className="control">

                            <label>First Name </label>&nbsp;<label ref="errors_first_name" className="disnone"></label>
                            <input type="text" id="profileFocus" ref="first_name" name="first_name" maxLength="20" value={this.state.first_name} onChange={this.handleInputChange} />
                          </div>
                          <div className="control">
                            <label>Last Name </label>&nbsp;<label ref="errors_last_name" className="disnone" ></label>
                            <input type="text" ref="last_name" name="last_name" maxLength="20" value={this.state.last_name} onChange={this.handleInputChange} />
                          </div>
                          <div className="control">
                            <label>Contact Number </label>&nbsp;<label ref="errors_phone_number" className="disnone"  ></label><br/>
                            <div style={{display:'flex'}}>
                              <div className="mobile-country">
                                <select value={this.state.countryPrefix} onChange={this.handleInputChange} name="countryPrefix" >
                                  <option value="">Prefix</option>
                                  {mapPrefixNumber.map(prefix =>
                                    <option value={prefix.value}>{prefix.label}</option>
                                  )}
                                </select>
                              </div>
                            <input type="text" style={{margin:'0px 0px 0px 71px'}} ref="phone_number" name="phone_number" maxLength="10" value={this.state.phone_number} onChange={this.handleInputChange} autoComplete="off" />
                            </div>
                          </div>
                          <div className="control">
                            <label>Gender <em>(optional)</em></label>
                            <div className="break">
                              <div className="radio">
                                <input id="customer-gender-male" type="radio" name="gender" value="male" checked={(this.state.gender === "male")} ref="male" onClick={this.handleInputChange} />
                                <label htmlFor="customer-gender-male">Male&nbsp;</label>
                              </div>
                              <div className="radio">
                                <input id="customer-gender-female" type="radio" name="gender" value="female" checked={(this.state.gender === "female")} ref="female" onClick={this.handleInputChange} />
                                <label htmlFor="customer-gender-female"> Female</label>
                              </div>
                            </div>
                          </div>
                          <div className="input-wrapper group-input">
                            <div className="control">
                              <label>Birthday <em>(optional)</em></label>
                              <div className="input-group calendar" data-do="datetime">
                                <span className="view" ref="birthdate">{this.formatDateOnly(this.state.birthdate, '-', '/')}</span>
                                <input id="datepicker"
                                  type="text"
                                  name="birthdate"
                                  value={this.state.birthdate}
                                  ref="birthday"
                                  onClick={this.handleInputChange}
                                  readOnly
                                />
                                <span className="input-group-addon">
                                  <i className="fa fa-calendar"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="control">
                            <button type="submit" className="btn btn-register btn-orange">
                              Save
                              </button>  <a data-toggle="collapse" data-target="#profile" ref="profile_cancel" data-do="datetime" className="cancel" onClick={this.handleCancel.bind(this, "Profile", true)}>Cancel</a>
                          </div>
                        </form>
                      </div>
                      {/* PROFILE DIV END */}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {/* EMAIL DIV START */}
                      {this.state.IsEmailUp ?
                        <div className="edit-account" data-toggle="collapse" data-target="#email" aria-hidden="true" onClick={this.toggleEmail.bind(this, "Email")}>
                          <i className="fa fa-caret-down pull-left"></i>
                          <span className="pull-left">Email</span>
                        </div>
                        :
                        <div className="collapsebtn edit-account" data-toggle="collapse" data-target="#email" aria-hidden="true" onClick={this.toggleEmail.bind(this, "Email")}>
                          <i className="fa fa-caret-right pull-left "></i>
                          <span className="pull-left ">Email</span>
                          <a className="pull-right  collapsebtn" data-toggle="collapse" data-target="#email" aria-hidden="true" onClick={this.toggleEmail.bind(this, "Email")}  > Edit</a>
                        </div>
                      }
                      <div id="email" className="collapse">
                        <div></div>
                        <form className="account-info" onSubmit={this.handleEmail}>
                          <div className="disnone">
                            <div ref="notify_success_email" className="sc-alert sc-alert-success"><i className="sc"></i>Email successfully updated. We have sent you an email about changing your email address.</div>
                            <div ref="notify_error_email" className="sc-alert sc-alert-danger"><i className="sc"></i>Please validate all fields.</div>
                          </div>
                          <div className="control">

                            <label>Email Address</label>&nbsp;<label ref="errors_email" className="disnone" ></label>

                            <input type="email" id="emailFocus" ref="email" maxLength="255" name="email" onChange={this.handleInputChange} value={this.state.email} autoComplete="off"/>
                          </div>
                          {this.props.login.fetched ? this.props.login.login.party.fb_id ? null :
                            <div className="control">
                              <label>Password </label>&nbsp;
                                <label ref="errors_password_confirm" className="disnone" ></label>
                                <div className="input-group">
                                  <input
                                    type="password"
                                    maxLength="100"
                                    className="form-control"
                                    name="password_confirm"
                                    ref="password_confirm"
                                    value={this.state.password_confirm}
                                    onChange={this.handleInputChange}/>
                                  <div className="input-group-addon">
                                    <div className="checkbox checkbox_nomargin">
                                      <input
                                        id="show_password_confirm"
                                        name="password_confirm"
                                        type="checkbox"
                                        ref="show_password_confirm"
                                        onClick={(e) => this.handleShowPassword(e)}
                                      />
                                      <label htmlFor="show_password_confirm">SHOW</label>
                                    </div>
                                  </div>
                                </div>
                            </div>
                          : null}
                          <div className="control">
                            <button type="submit" className="btn btn-register btn-orange" disabled={this.handleEnableButton()}>
                              Save
                                </button>  <a data-toggle="collapse" data-target="#email" ref="email_cancel" className="cancel" onClick={this.handleCancel.bind(this, "Email", true)}>Cancel</a>
                          </div>
                        </form>
                      </div>
                      {/* EMAIL DIV END */}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {/* PASSWORD DIV START */}
                      {this.state.IsPasswordUp ?
                        <div className="edit-account" data-toggle="collapse" data-target="#password" aria-hidden="true" onClick={this.togglePassword.bind(this, "Password")}>
                          <i className="fa fa-caret-down pull-left  "></i>
                          <span className="pull-left  ">Password</span>
                        </div>
                        :
                        <div className="collapsebtn edit-account" data-toggle="collapse" data-target="#password" aria-hidden="true" onClick={this.togglePassword.bind(this, "Password")}>
                          <i className="fa fa-caret-right pull-left  "></i>
                          <span className="pull-left  ">Password</span>
                          <a className="pull-right   collapsebtn" data-toggle="collapse" data-target="#password" aria-hidden="true" onClick={this.togglePassword.bind(this, "Password")}> Edit</a>
                        </div>
                      }
                      <div id="password" className="collapse">
                        <div></div>
                        <form className="account-info" ref="" method="PUT" onSubmit={this.handlePassword}>
                          <div className="disnone">
                            <div ref="notify_success_password" className="sc-alert sc-alert-success"><i className="sc"></i>You can now use your new password to access your ShippingCart account! <br /> &nbsp; &nbsp; &nbsp; &nbsp; We have sent you an email about changing your password.</div>
                            <div ref="notify_error_password" className="sc-alert sc-alert-danger"><i className="sc"></i>Please validate all fields.</div>
                          </div>
                          <div className="control">
                            <label>Current Password </label>&nbsp;


                              <label ref="errors_password" className="disnone" ></label>

                            <div className="input-group">
                              <input type="password" className="form-control" id="passwordFocus" maxLength="100" name="password" ref="password" />
                              <div className="input-group-addon">
                                <div className="checkbox checkbox_nomargin">
                                  <input
                                    id="show_password"
                                    name="password"
                                    type="checkbox"
                                    ref="show_password"
                                    onClick={(e) => this.handleShowPassword(e)}
                                  />
                                  <label htmlFor="show_password">SHOW</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="control">
                            <label>New Password </label>&nbsp;

                              <label ref="errors_new_password" className="disnone" ></label>

                            <div className="input-group">
                              <input type="password" className="form-control" maxLength="100" name="new_password" ref="new_password" />
                              <div className="input-group-addon">
                                <div className="checkbox checkbox_nomargin">
                                  <input
                                    id="show_new_password"
                                    name="new_password"
                                    type="checkbox"
                                    ref="show_new_password"
                                    onClick={(e) => this.handleShowPassword(e)}
                                  />
                                  <label htmlFor="show_new_password">SHOW</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="control">
                            <label>Re-enter Password </label>&nbsp;

                              <label ref="errors_new_confirm_password" className="disnone" ></label>

                            <div className="input-group">
                              <input type="password" className="form-control" maxLength="100" name="new_confirm_password" ref="new_confirm_password" />
                              <div className="input-group-addon">
                                <div className="checkbox checkbox_nomargin">
                                  <input
                                    id="show_new_confirm_password"
                                    name="new_confirm_password"
                                    type="checkbox"
                                    ref="show_new_confirm_password"
                                    onClick={(e) => this.handleShowPassword(e)}
                                  />
                                  <label htmlFor="show_new_confirm_password">SHOW</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="control">
                            <button type="submit" className="btn btn-register btn-orange">
                              Save
                              </button>
                            <a data-toggle="collapse" data-target="#password" ref="password_cancel" className="cancel" onClick={this.handleCancel.bind(this, "Password", true)}>Cancel</a>
                          </div>
                        </form>
                      </div>
                      {/* PASSWORD DIV END */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/*<div role="tabpanel" className="tab-pane" id="rewards">
            <h2> This page will be available soon. </h2>
          </div>*/}
        </div>
        <Modal 
          onHide={this.handleModalHide}
          show={this.state.showModal}
          >
          <Modal.Header style={{ marginBottom: 0, paddingBottom: 0 }}>
            <Modal.Title style={{ color: '#333333', fontWeight
          : 600 }}>{this.state.modalTitle}</Modal.Title>
            <p className="pull-right" style={{ color: '#707070', fontSize: 12, marginTop: 5 }}>All fields are required.</p>
          </Modal.Header>

          <Modal.Body style={{ padding: 20, color: '#707070'}}>
          <div className="disnone">
                <div ref="notify_error_add_first_name" className="sc-alert sc-alert-danger" style={{ margin: 0, width: '100%' }}><i className="sc"></i><span>Fill in all fields to add address.</span></div>
              </div>
              <form id="address" onSubmit={this.formAddress} className="form-horizontal">
                <section>
                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label'>First Name </label>&nbsp;<label ref="errors_add_first_name" className="disnone"  ></label>
                    <input placeholder="Enter details here" type="text" onChange={this.handleInputChange} id="add_first_name" name="add_first_name" maxLength="20" ref="add_first_name" className="account-form-control letter-only" value={this.state.add_first_name} />
                  </div>


                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >Last Name </label>&nbsp;<label ref="errors_add_last_name" className="disnone"  ></label>
                    <input placeholder="Enter details here" type="text" onChange={this.handleInputChange} name="add_last_name" maxLength="20" ref="add_last_name" className=" account-form-control letter-only" value={this.state.add_last_name} />
                  </div>



                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >Street Address </label>&nbsp;<label ref="errors_add_line_1" className="disnone"  ></label>
                    <input placeholder="Enter details here" type="text" onChange={this.handleInputChange} name="street" maxLength="255" ref="street" className=" account-form-control letter-only" value={this.state.street} />
                  </div>

                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >Country</label>&nbsp;<label ref="errors_add_country_code" className="disnone"  ></label>

                    <select placeholder="Select Province" onChange={this.handleCountries} className="account-form-control" name="country" ref="country">
                      <option value="" disabled selected>Select Country</option>
                      <option value="PH">Philippines</option>
                      {/* <option value="MY">Malaysia</option> */}
                    </select>
                    <img src={DropdownIcon} alt='icon' className="account-dropdown-icon" />

                  </div>

                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >{this.state.country === "MY" ? "State/Province" : "Province"}</label>&nbsp;<label ref="errors_add_state" className="disnone"  ></label>

                    <select placeholder="Select Province" value={this.state.province} onChange={this.handleProvinces} className="account-form-control" name="province" disabled={this.state.enableProvince ? "" : "disabled"} ref="province">
                      <option value="" disabled selected>Select {this.state.country === "MY" ? "State/Province" : "Province"}</option>
                      {
                        this.props.login.provinces ? (this.props.login.provinces.data || this.props.login.provinces).map((add, i) =>
                          <option key={i} value={add.name} data-province-id={add.id} data-region={add.parent_id}>{add.name}</option>
                        ) : null
                      }
                    </select>
                  </div>

                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >City</label>&nbsp;<label ref="errors_add_city" className="disnone"  ></label>
                    <select value={this.state.city} onChange={this.handleCities} className="account-form-control" name="city" disabled={this.state.enableCity ? "" : "disabled"} ref="city">
                      <option value="" disabled selected>Select City</option>
                      {
                        this.props.login.cities ? (this.props.login.cities.data || this.props.login.cities).map((add, i) =>
                          <option key={i} value={add.name} data-city-id={add.id}>{add.name}</option>
                        ) : null
                      }
                    </select>
                    <img src={DropdownIcon} alt='icon' className="account-dropdown-icon" />
                  </div>

                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >{ this.state.country === "MY" ? "District/Barangay" : "Barangay"}</label>&nbsp;<label ref="errors_add_line_2" className="disnone"></label>
                    <select value={this.state.district} onChange={this.handleDistricts} className="account-form-control" name="district" disabled={this.state.enableDistrict ? "" : "disabled"} ref="districts">
                      <option value="">Select { this.state.country === "MY" ? "District/Barangay" : "Barangay"}</option>
                      {
                        this.props.login.districts ? (this.props.login.districts.data || this.props.login.districts).map((add, i) =>
                          <option key={i} value={add.id} data-district-id={add.id} data-postal-code={add.postal_code} data-district-name={add.name}>{add.name} {this.state.country === "MY" && `(${add.postal_code})`}</option>
                        ) : null
                      }
                    </select>
                    <img src={DropdownIcon} alt='icon' className="account-dropdown-icon" />
                  </div>
                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label' >Postal </label>&nbsp;<label ref="errors_add_postal_code" className="disnone"></label>
                    <input type="text" className="account-form-control letter-only" disabled="disabled" ref="postal" value={this.state.postal_code} />
                  </div>
                  
                  <div style={{ marginTop: 15 }}>
                    <label className='account-form-label'>Contact Number </label>&nbsp;<label ref="errors_add_phone_number" className="disnone"></label><br/>
                    <div style={{display:'flex'}}>
                      <div>
                        <select style={{ width: 75 }} value={this.state.add_countryPrefix} onChange={this.handleInputChange} name="add_countryPrefix" className="account-form-control" >
                          <option value="">Prefix</option>
                          {mapPrefixNumber.map(prefix =>
                            <option value={prefix.value}>{prefix.label}</option>
                          )}
                        </select>
                        <img src={DropdownIcon} alt='icon' className="account-dropdown-icon" style={{ left: 77 }}/>
                      </div>
                    <input type="text" style={{margin:'0px 0px 0px 20px', width: '100%'}} ref="phone_number" name="address_phone_number" maxLength="10" value={this.state.address_phone_number} onChange={this.handleInputChange} autoComplete="off" className="account-form-control" />
                    </div>
                  </div>
          
                </section>


                <div className="account-modal-footer" style={{ marginTop: 15 }}>
                  <input className="account-add-address-button " value={this.state.submitText} type="submit" />
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <a style={{ color: '#707070', fontWeight: 600, fontSize: 14  }} onClick={this.handleCancel.bind(this, "Address", true)} ref="modal_address_cancel" data-dismiss="modal" aria-label="Close">CANCEL</a>
                  </div>
                </div>


              </form>
          </Modal.Body>
        </Modal>
         <Modal 
          onHide={() => this.setState({deleteAddressModal: ""})}
          show={this.state.deleteAddressModal}
          className="delete-address-modal"
          >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>

          <Modal.Body>
                <section className="modal-body">
                  <p className="delete-modal-content">Are you sure you want to delete this address?</p>
                </section>
                <div className="modal-footer">
                  <button className="delete-button-yes" onClick={() => this.handleDeleteButton(this.state.deleteAddressModal)}>YES</button>
                  <button className="delete-button-no" onClick={() => this.setState({deleteAddressModal: ""})}>NO</button>
                </div>
          </Modal.Body>
        </Modal>
        {/* ADDRESS MODAL START */}
        {/* <div id="modal_add_address" ref="modal_address" className="modal address">
          <div className="modal-dialog">
            <div className="modal-content">
              <header className="modal-header">
                <button type="button" className="close" data-dismiss="modal" onClick={this.handleCancel.bind(this, "Address", true)} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" ref="modal_header">{""}</h4>
                <p className="pull-right required-fields">All fields are required.</p>
              </header>
              <div className="disnone">
                <div ref="notify_error_add_first_name" className="sc-alert sc-alert-danger"><i className="sc"></i><span>Fill in all fields to add address.</span></div>
              </div>
              <form id="address" onSubmit={this.formAddress} className="form-horizontal">
                <section className="modal-body">
                  <div className="control">
                    <label>First Name </label>&nbsp;<label ref="errors_add_first_name" className="disnone"  ></label>
                    <input type="text" onChange={this.handleInputChange} name="add_first_name" maxLength="20" ref="add_first_name" className="form-control letter-only" value={this.state.add_first_name} />
                  </div>


                  <div className="control">
                    <label>Last Name </label>&nbsp;<label ref="errors_add_last_name" className="disnone"  ></label>
                    <input type="text" onChange={this.handleInputChange} name="add_last_name" maxLength="20" ref="add_last_name" className=" form-control letter-only" value={this.state.add_last_name} />
                  </div>



                  <div className="control">
                    <label>Street Address </label>&nbsp;<label ref="errors_add_line_1" className="disnone"  ></label>
                    <input type="text" onChange={this.handleInputChange} name="street" maxLength="40" ref="street" className=" form-control letter-only" value={this.state.street} />
                  </div>



                  <div className="control">
                    <label>Province</label>&nbsp;<label ref="errors_add_state" className="disnone"  ></label>

                    <select value={this.state.province} onChange={this.handleProvinces} className="form-control" name="province" ref="province">
                      <option value="">--- Select Province ---</option>
                      {
                        this.props.login.provinces ? this.props.login.provinces.map((add, i) =>

                          <option key={i} value={add.name} data-province-id={add.id} data-region={add.parent_id}>{add.name}</option>
                        ) : null
                      }
                    </select>
                  </div>

                  <div className="control">
                    <label>City</label>&nbsp;<label ref="errors_add_city" className="disnone"  ></label>
                    <select value={this.state.city} onChange={this.handleCities} className="form-control" name="city" disabled={this.state.enableCity ? "" : "disabled"} ref="city">
                      <option value="">--- Select City ---</option>
                      {
                        this.props.login.cities ? this.props.login.cities.map((add, i) =>
                          <option key={i} value={add.name} data-city-id={add.id}>{add.name}</option>
                        ) : null
                      }
                    </select>
                  </div>

                  <div className="control">
                    <label>Barangay</label>&nbsp;<label ref="errors_add_line_2" className="disnone"></label>
                    <select value={this.state.district} onChange={this.handleDistricts} className="form-control" name="district" disabled={this.state.enableDistrict ? "" : "disabled"} ref="districts">
                      <option value="">--- Select Barangay ---</option>
                      {
                        this.props.login.districts ? this.props.login.districts.map((add, i) =>
                          <option key={i} value={add.name} data-district-id={add.id} data-postal-code={add.postal_code}>{add.name}</option>
                        ) : null
                      }
                    </select>
                  </div>
                  <div className="control">
                    <label>Postal </label>&nbsp;<label ref="errors_add_postal_code" className="disnone"></label>
                    <input type="text" className="form-control letter-only" disabled="disabled" ref="postal" value={this.state.postal_code} />
                  </div>
                </section>


                <div className="modal-footer">
                  <input className="btn btn-orange address-submit add-address " value={this.state.submitText} type="submit" />
                  &nbsp; &nbsp; &nbsp;<a onClick={this.handleCancel.bind(this, "Address", true)} ref="modal_address_cancel" data-dismiss="modal" aria-label="Close">Cancel</a>
                </div>


              </form>
            </div>
          </div>
        </div> */}
        {/* ADDRESS MODAL END */}

      </div>
    )
  },
});



export default Account;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/Account.js
 **/